import { useEffect, useState } from "react";
import axios from "axios";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";
import { resolveContent } from "@/lib/images";

const API = `${process.env.REACT_APP_BACKEND_URL || 'https://smapi.sanmartino26.al'}/api`;

const ContactPage = () => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    document.title = "Kontakt — San Martino 26";
    window.scrollTo(0, 0);
    let cancelled = false;
    axios.get(`${API}/content`).then((res) => {
      if (!cancelled) setContent(resolveContent(res.data));
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return (
    <main data-testid="contact-page" className="bg-sm-inverse text-sm-bg min-h-screen flex flex-col">
      <Navigation brand={content?.brand} />
      <div className="flex-1 flex flex-col justify-end pt-16 md:pt-20">
        {content && <Footer content={content.footer} />}
      </div>
      <FloatingButtons number={content?.brand?.whatsapp_number} />
    </main>
  );
};

export default ContactPage;
